export const REFLECTIONS_FEATURE_KEY = 'reflections';
